import React, { useState, useRef } from "react";
import Slider from "react-slick";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import language from "../../../helpers/language";
import thumbnail1 from "../../../assets/new-home/academy-thumbnails/image00001.jpg";
import thumbnail6 from "../../../assets/new-home/academy-thumbnails/image00006.jpg";
import thumbnail11 from "../../../assets/new-home/academy-thumbnails/image00011.jpg";
import thumbnail17 from "../../../assets/new-home/academy-thumbnails/image00017.jpg";
import thumbnail18 from "../../../assets/new-home/academy-thumbnails/image00018.jpg";
import thumbnail21 from "../../../assets/new-home/academy-thumbnails/image00021.jpg";
import thumbnail22 from "../../../assets/new-home/academy-thumbnails/image00022.jpg";
import thumbnail23 from "../../../assets/new-home/academy-thumbnails/image00023.jpg";
import thumbnail24 from "../../../assets/new-home/academy-thumbnails/image00024.jpg";

const optimizedThumbnails = {
  1: thumbnail1,
  2: thumbnail6,
  3: thumbnail18,
  // 4: thumbnail17,
  // 5: thumbnail11,
  // 6: thumbnail21,
  7: thumbnail22,
  // 8: thumbnail23,
  // 9: thumbnail24,
};

const NewAcademy = () => {
  const [playingVideo, setPlayingVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sliderRef = useRef(null);
  const lang = language.getLang();
  const videoList = lang.videoList;

  const handlePlayVideo = (id) => {
    setPlayingVideo(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPlayingVideo(null);
  };

  const activeVideo = videoList.find((video) => video.id === playingVideo);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 600,
    lazyLoad: "ondemand",
    slidesToShow: 4,
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="md:px-14 px-4 md:pt-6 md:pb-6 py-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <AnimateFromBottom delay={0.2}>
            <div className="flex items-start justify-between mb-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-black mb-2">
                  Alysei Academy
                </h2>
                <p className="text-sm text-gray-500">{lang.Videos_subtitle}</p>
              </div>
              {/* <div className="flex items-center gap-2 flex-shrink-0 mt-1">
                <button
                  type="button"
                  onClick={() => sliderRef.current?.slickPrev()}
                  className="w-10 h-10 rounded-md border border-gray-300 bg-white flex items-center justify-center hover:bg-gray-50 transition-colors shadow-sm"
                  aria-label="Previous"
                >
                  <i className="fa fa-arrow-left text-gray-700 text-sm" />
                </button>
                <button
                  type="button"
                  onClick={() => sliderRef.current?.slickNext()}
                  className="w-10 h-10 rounded-md flex items-center justify-center transition-colors shadow-sm"
                  style={{ backgroundColor: "#1a3a5c" }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = "#152e4a"}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = "#1a3a5c"}
                  aria-label="Next"
                >
                  <i className="fa fa-arrow-right text-white text-sm" />
                </button>
              </div> */}
            </div>
          </AnimateFromBottom>

          <AnimateFromBottom delay={0.3}>
            {/* Desktop: plain grid, no scroll */}
            <div className="hidden md:grid md:grid-cols-4 gap-4">
              {videoList.map((video) => (
                <article key={video.id} className="relative rounded-xl overflow-hidden h-44 bg-gray-100 group card--hover">
                  <img
                    src={optimizedThumbnails[video.id] || video.image}
                    alt={video.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                  <h3 className="absolute left-3 bottom-3 pr-12 text-white text-xs font-semibold leading-tight">
                    {video.title}
                  </h3>
                  <button
                    type="button"
                    className="play-btn absolute right-3 bottom-3 w-9 h-9 rounded-xl bg-white flex items-center justify-center shadow-md transition-colors duration-200"
                    onClick={() => handlePlayVideo(video.id)}
                    aria-label={`Play ${video.title}`}
                  >
                    <i className="fas fa-play text-xs text-brand-dark-blue transition-colors duration-200" aria-hidden="true" />
                  </button>
                </article>
              ))}
            </div>

            {/* Mobile: slider */}
            <div className="md:hidden new-home-academy-slider overflow-hidden" style={{ padding: "0 10px" }}>
              <Slider ref={sliderRef} {...settings}>
                {videoList.map((video) => (
                  <div key={video.id}>
                    <article className="relative rounded-xl overflow-hidden h-36 bg-gray-100 group card--hover">
                      <img
                        src={optimizedThumbnails[video.id] || video.image}
                        alt={video.title}
                        loading="lazy"
                        decoding="async"
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                      <h3 className="absolute left-3 bottom-3 pr-12 text-white text-xs font-semibold leading-tight">
                        {video.title}
                      </h3>
                      <button
                        type="button"
                        className="play-btn absolute right-3 bottom-3 w-9 h-9 rounded-xl bg-white flex items-center justify-center shadow-md transition-colors duration-200"
                        onClick={() => handlePlayVideo(video.id)}
                        aria-label={`Play ${video.title}`}
                      >
                        <i className="fas fa-play text-xs text-brand-dark-blue transition-colors duration-200" aria-hidden="true" />
                      </button>
                    </article>
                  </div>
                ))}
              </Slider>
              <div className="mt-4 flex items-center justify-center gap-3">
                <button
                  type="button"
                  onClick={() => sliderRef.current?.slickPrev()}
                  className="w-10 h-10 rounded-lg border border-gray-300 bg-white flex items-center justify-center shadow-sm transition-colors duration-200 hover:bg-gray-50"
                  aria-label="Previous academy video"
                >
                  <i className="fa fa-arrow-left text-sm text-gray-700" aria-hidden="true" />
                </button>
                <button
                  type="button"
                  onClick={() => sliderRef.current?.slickNext()}
                  className="w-10 h-10 rounded-lg bg-brand-dark-blue flex items-center justify-center shadow-sm transition-colors duration-200 hover:bg-brand-dark-blue/90"
                  aria-label="Next academy video"
                >
                  <i className="fa fa-arrow-right text-sm text-white" aria-hidden="true" />
                </button>
              </div>
            </div>
          </AnimateFromBottom>
        </div>
      </section>

      {isModalOpen && activeVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg w-11/12 md:w-1/2 relative">
            <button
              className="absolute top-4 right-4 text-white text-3xl"
              onClick={handleCloseModal}
              style={{ zIndex: 1000 }}
              aria-label="Close video"
            >
              &times;
            </button>
            <iframe
              className="w-full h-96"
              src={activeVideo.videoUrl}
              title={activeVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
};

export default NewAcademy;
